/*
 * Variant image overlay.
 *
 * Renders a transparent PNG (per-variant detail, e.g. light-strip placement)
 * on top of the currently displayed product gallery image, so minor detail
 * variants don't each need their own gallery photo.
 *
 * Data map ({ variantId: { url, media } }) is emitted inline by
 * snippets/product-form-2.liquid as <script data-gallery-overlay-data>.
 * `media` is the id of the gallery figure the overlay belongs to (the
 * variant's featured_media, or the product's main image as a fallback), so
 * the overlay only shows while that image is the one on screen.
 */
(function () {
  function init() {
    var dataEl = document.querySelector('[data-gallery-overlay-data]');
    var viewer = document.querySelector('[data-gallery-viewer]');
    var variantSelection = document.querySelector('variant-selection');

    if (!dataEl || !viewer || !variantSelection) return;

    var overlays;
    try {
      overlays = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    // Nothing to do if no variant has an overlay configured.
    if (!overlays || Object.keys(overlays).length === 0) return;

    // Warm the browser cache with every overlay image (deduped, low priority)
    // so selecting a variant swaps the src instantly instead of downloading.
    var preloaded = [];
    function preloadAll() {
      var seen = {};
      Object.keys(overlays).forEach(function (id) {
        var url = overlays[id] && overlays[id].url;
        if (!url || seen[url]) return;
        seen[url] = true;
        var img = new Image();
        if ('fetchPriority' in img) img.fetchPriority = 'low';
        img.src = url;
        preloaded.push(img); // keep a reference so it isn't garbage collected
      });
    }
    if ('requestIdleCallback' in window) {
      requestIdleCallback(preloadAll);
    } else {
      preloadAll();
    }

    // The single overlay <img>, moved between figures as the selection changes.
    var overlayImg = document.createElement('img');
    overlayImg.className = 'product-gallery--overlay';
    overlayImg.setAttribute('data-gallery-overlay', '');
    overlayImg.setAttribute('aria-hidden', 'true');
    overlayImg.alt = '';

    var currentEntry = null;

    function selectedFigure() {
      return viewer.querySelector(
        '[data-gallery-figure][data-gallery-selected="true"]'
      );
    }

    // Attach the overlay into the given figure's image container so it aligns
    // with (and moves with) that image.
    function place(figure) {
      var host = figure.querySelector('.product-gallery--image-background') || figure;

      // Ensure the host is a positioning context for the absolute overlay.
      if (getComputedStyle(host).position === 'static') {
        host.style.position = 'relative';
      }

      if (overlayImg.parentNode !== host) {
        host.appendChild(overlayImg);
      }
    }

    function render() {
      var figure = currentEntry ? selectedFigure() : null;
      // Show only when the displayed image is the overlay's target media.
      var onTarget =
        figure && String(figure.dataset.media) === String(currentEntry.media);

      if (onTarget) {
        place(figure);
        if (overlayImg.getAttribute('src') !== currentEntry.url) {
          overlayImg.src = currentEntry.url;
        }
        overlayImg.style.opacity = '1';
      } else {
        overlayImg.style.opacity = '0';
      }
    }

    function setVariant(variant) {
      currentEntry = variant && overlays[variant.id] ? overlays[variant.id] : null;
      render();
    }

    // Update the overlay image whenever the variant changes.
    variantSelection.addEventListener('variant-change', function (e) {
      setVariant(e.detail && e.detail.variant);
    });

    // Re-evaluate when the displayed image changes (thumbnail clicks, swipes,
    // variant-driven media switches) — data-gallery-selected flips on figures.
    var observer = new MutationObserver(function () {
      render();
    });
    viewer.querySelectorAll('[data-gallery-figure]').forEach(function (figure) {
      observer.observe(figure, {
        attributes: true,
        attributeFilter: ['data-gallery-selected'],
      });
    });

    // Apply for the variant selected on page load.
    var initialId = variantSelection.getAttribute('variant');
    if (initialId && overlays[initialId]) {
      currentEntry = overlays[initialId];
      render();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
